import React from 'react';

import { useIntl } from 'react-intl-next';

import Heading from '@atlaskit/heading';
import { Box, Stack, Text, xcss } from '@atlaskit/primitives';

import gesturalLine from './assets/gestural-line.svg';
import { messages } from './messages';

/**
 * This the recommendation text and graphic that points out to the user that they should go for Standard.
 */
export const FloatingRecommendation = () => {
	const { formatMessage } = useIntl();

	return (
		<>
			<Stack xcss={floatingTextboxStyles} space="space.050">
				<Heading size="medium">{formatMessage(messages.recommended)}</Heading>
				<Text size="medium">{formatMessage(messages.basedOnYourUsage)}</Text>
			</Stack>
			<Box xcss={gesturalLineStyles}>
				<img src={gesturalLine} alt={formatMessage(messages.gesturalLineAltText)} />
			</Box>
		</>
	);
};

const gesturalLineStyles = xcss({
	top: '75px',
	left: '58px',
	zIndex: 'dialog',
	position: 'relative',
});

const floatingTextboxStyles = xcss({
	top: '62px',
	left: '45px',
	zIndex: 'dialog',
	position: 'relative',
});
